<template>
  <div>
    <h3 class="color-darkblue">Failure</h3>
    <div class="form-row row-cols-md-4 row-cols-1">
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label require">Failure Date:</label>
        </div>
        <div class="input-group">
          <date-picker placeholder="MM/DD/YYYY" id="failure_date" name="failure_date" v-model="failure_date"
            :config="optionsDate"></date-picker>
          <label for="failure_date" class="fp-calendar input-calender-icon"></label>
        </div>
        <div class="field-error">{{ failure_date_error_msg }}</div>
      </div>
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label require">Repair Date:</label>
        </div>
        <div class="input-group">
          <date-picker placeholder="MM/DD/YYYY" id="repair_date" name="repair_date" v-model="repair_date"
            :config="optionsDate"></date-picker>
          <label for="repair_date" class="fp-calendar input-calender-icon"></label>
        </div>
        <div class="field-error">{{ repair_date_error_msg }}</div>
      </div>
    </div>
    <h4>Major Component:</h4>
    <div class="form-row row-cols-md-4 row-cols-1">
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label">Current MFG S/N:</label>
        </div>
        <input type="text" id="current_mfg_sn" v-model="current_mfg_sn" class="form-control" disabled>
      </div>
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label">New MFG S/N:</label>
        </div>
        <input type="text" id="new_mfg_sn" v-model="new_mfg_sn" class="form-control" disabled>
      </div>
    </div>
    <h4>Failed Part Section</h4>
    <div class="form-row row-cols-md-4 row-cols-1">
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label require">Root Cause Part (RCP):</label>
        </div>
        <v-select v-model="primary_failed_part" name="primary_failed_part" label="text" :filterable="false"
          :options="componentArr" @search="onSearchComponent" placeholder="Search Part" class="custom-ci-auto-search">
          <template slot="no-options">
            Search Part...
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.text }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.text }}
            </div>
          </template>
        </v-select>
        <div class="field-error">{{ pfp_error_msg }}</div>
      </div>
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label require">Position/Component Code:</label>
        </div>
        <v-select v-model="position_code" id="position" label="text" :options="positionArr" @search="onSearchPositionCode"
          placeholder="Select Position" class='custom-ci-auto-search contract-data' :disabled="disableAll">
          <template slot="no-options">
            Search Position...
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.text }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.text }}
            </div>
          </template>
        </v-select>
        <div class="field-error">{{ position_error_msg }}</div>
      </div>
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label require">Damage/Cause Code:</label>
        </div>
        <v-select v-model="damage_cause" name="damage_cause" label="text" :filterable="false" :options="reasonArr"
          @search="onSearchReason" placeholder="Search Cuase" class="custom-ci-auto-search">
          <template slot="no-options">
            Search Cause...
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.text }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.text }}
            </div>
          </template>
        </v-select>
        <div class="field-error">{{ damage_cause_error_msg }}</div>
      </div>
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label">Part Disposition:</label>
        </div>
        <input type="text" id="part_disposition" v-model="part_disposition" class="form-control" disabled>
      </div>
    </div>
    <div class="form-row row-cols-md-4 row-cols-1">
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label require">Complaint/Condition:</label>
        </div>
        <textarea v-model="complaint_condition" id="complaint_condition" cols="35" rows="5"></textarea>
      </div>
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label require">Cause:</label>
        </div>
        <textarea v-model="cause" id="cause" cols="35" rows="5"></textarea>
      </div>
      <div class="col form-group">
        <div class="example-label require">
          <label class="control-label">Work Performed/Correction:</label>
        </div>
        <textarea v-model="correction" id="correction" cols="35" rows="5" @input="limitWords"></textarea>
        <div class="field-error">{{ correction_error_message }}</div>
      </div>
    </div>
    <div class="btn-groups mt-3">
      <button type="button"
      v-on:click="updateFormSection()" class="btn btn-primary">
      <i class="fp-edit"></i> Edit
    </button>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { contractMixins } from "../../mixins/contractMixins";
import { commonMixins } from "../../mixins/commonMixins";

export default {
  name: "EvFailureFormSection",
  props: ["failureTabData","claimId","hideEditSection"],
  mixins: [commonMixins, contractMixins],
  data: () => ({
    componentArr: [],
    disableAll: false,
    component: "",
    failure_date: "",
    repair_date: "",
    current_mfg_sn: "",
    current_model_number: "",
    new_mfg_sn: "",
    new_model_number: "",
    primary_failed_part: "",
    supplier: "",
    cause: "",
    damage_cause: "",
    corrective_action: "",
    part_disposition: "",
    repair_details: "",
    position_code: "",
    positionArr: [],
    failure_date_error_msg: "",
    repair_date_error_msg: "",
    pfp_error_msg: "",
    component_error_msg: "",
    position_error_msg: "",
    cause_error_msg: "",
    damage_cause_error_msg: "",
    corrective_action_error_msg: "",
    optionsDate: {
      format: 'MM/DD/YYYY',
      useCurrent: false,
    },
    complaint_condition: "",
    correction: "",
    reasonArr: [],
    correction_error_message: "",
  }),
  created(){
    this.populateData();
  },
  methods:{
    onSearchComponent(search, loading) { // function to handle the searchable drop down of parts
      var self = this;
      if (search.length > 2) {

        loading(true);
        self.searchField(loading, search, 'component', '');
      }
    },
    onSearchPositionCode(search, loading) {
      var self = this;
      if (search.length > 2) {

        loading(true);
        self.searchField(loading, search, 'failed_part_positions', '');
      }
    },
    onSearchReason(search, loading) {
      var self = this;
      if (search.length > 2) {

        loading(true);
        self.searchField(loading, search, 'reason', '');
      }
    },
    limitWords(event) {
      var self = this;
      var wordCount = self.correction.split(/\s+/).filter(word => word.length > 0).length;
      if (wordCount > 3000) {
        if (event.inputType === 'deleteContentBackward') {
          self.correction_error_message = "";
        }else{
          event.preventDefault();
          self.correction_error_message = "Correction cannot be more than 3000 words!";
          self.correction = self.correction.split(/\s+/).slice(0, 3000).join(' ');
        }
      } else {
        self.correction_error_message = "";
      }
    },
    populateData(){
      this.primary_failed_part = { "value": this.failureTabData.failed_item_id, "text": this.failureTabData.failed_item_text };
      this.failure_date = this.failureTabData.failure_date;
      this.repair_date = this.failureTabData.repair_date;
      this.current_mfg_sn = this.failureTabData.current_mfg_sn;
      this.new_mfg_sn = this.failureTabData.new_mfg_sn;
      this.supplier = this.failureTabData.supplier;
      this.position_code = { "value": this.failureTabData.position_value, "text": this.failureTabData.position_text };
      this.cause = this.failureTabData.probable_cause;
      this.part_disposition = this.failureTabData.failed_part_disposition;
      this.repair_details = this.failureTabData.repair_details;
      this.damage_cause = this.failureTabData.damage_cause;
      this.complaint_condition = this.failureTabData.complaint_condition;
      this.correction = this.failureTabData.correction;
    },
    updateFormSection(){
      var self = this;
      const sectionData = this.prepareDataForUpdating();
      self.$parent.loading = true;
      $.ajax({
          url: process.env.ROOT_API + "/update/failure-form-section",
          type: "POST",
          data: {
            formSectionData: sectionData,
          },
          headers: this.ajxHeaders,
          dataType: "json",
          cors: true,
          success: function (data) {
            self.$parent.loading = false;
            if (data.status == "success") {
              self.hideEditSection("failure_form_section");
            } else {
              console.log("Error");
            }
          },
          error: function (jqXHR, exception) {
            self.$parent.loading = false;
            console.log("ERRORRRR");
          },
        });
    },
    prepareDataForUpdating(){
      const formSectionData = {
        component: this.component,
        failure_date: this.failure_date,
        repair_date: this.repair_date,
        current_mfg_sn: this.current_mfg_sn,
        new_mfg_sn: this.new_mfg_sn,
        primary_failed_part: this.primary_failed_part,
        supplier: this.supplier, // root cause part description
        position: this.position_code,
        damage_cause: this.damage_cause,
        part_disposition: this.part_disposition,
        repair_details: this.repair_details,
        complaint_condition: this.complaint_condition,
        correction: this.correction,
        cause: this.cause,
        claimId: this.claimId,
      };
      return formSectionData;
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvFailureFormSection.vue